import React, { memo, useCallback, useMemo } from 'react';
import { MapMarker } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, NO_ICON } from '@yme/atoms/button';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { useOutsideClick } from '@yme/hooks/useOutsideClick';
import { RowName } from '@yme/molecules/dealer-card/locator/RowName';
import { useTranslation } from '@yme/services/i18n';
import { colorCoreBlack300, colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { formatDistance } from '@yme/utils/common';
import { EVENT_NAME_MAP } from '@yme/utils/constants';
import { ContainerStyled, DistanceLabelStyled } from './styled';
export const DealerCardCheckoutMap = memo(({ name, distance, addressLines, zipCode, onSubmit, onDismiss, isMultipleSelection, isChecked, }) => {
    const { t } = useTranslation();
    const outsideCallback = useCallback(() => {
        if (onDismiss)
            onDismiss();
    }, [onDismiss]);
    const { elementRef } = useOutsideClick({
        eventName: EVENT_NAME_MAP.click,
        callback: outsideCallback,
    });
    const buttonLabel = useMemo(() => {
        if (isMultipleSelection) {
            if (isChecked) {
                return t('common_preferredDealer_unselect_dealer_button');
            }
            else {
                return t('common_preferredDealerFindDealerPopUpSelectDealer_button');
            }
        }
        return t('common_preferredDealerFindDealerPopUpSelectDealer_button');
    }, [isChecked, isMultipleSelection, t]);
    return (React.createElement(ContainerStyled, { ref: elementRef },
        React.createElement(FlexWrapper, { alignItems: "flex-start", justifyContent: "space-between" },
            React.createElement(RowName, { name: name }),
            Boolean(distance) && (React.createElement(FlexWrapper, { alignItems: "center" },
                React.createElement(DistanceLabelStyled, null,
                    React.createElement(RegularTextLevel4, { weight: 500, color: colorCoreBlack300 }, formatDistance(distance, t))),
                React.createElement(SVGIcon, { type: MapMarker })))),
        React.createElement(FlexWrapper, { mt: "12px", mb: "16px" },
            React.createElement(RegularTextLevel4, { color: colorCoreBlack900Base }, `${addressLines?.[0]}, ${zipCode}`)),
        onSubmit && (React.createElement(Button, { label: buttonLabel, buttonVariant: CONTAINED_VARIANT, hasIconButton: NO_ICON, onClick: onSubmit }))));
});
DealerCardCheckoutMap.displayName = 'DealerCardCheckoutMap';
